(function (skyward, $, undefined)
{
    skyward.massmovesectionstotargetcourse = skyward.massmovesectionstotargetcourse || {};

    "use strict";

    var init = function (selector)
    {
        var massMoveSectionsToTargetCourseCodeeel = $(selector).find("#MassMoveTargetCourseID");
        if (massMoveSectionsToTargetCourseCodeeel.length > 0)
        {
            $(massMoveSectionsToTargetCourseCodeeel).on("change", setCourseLengthFilterOnBrowse);
        }
        else
        {
            return;
        }
    };

    var setCourseLengthFilterOnBrowse = function ()
    {
        var browse = skyward.browse.browseList["SectionsToMove"];
        var courseID = skyward.controls.getValue($("#MassMoveTargetCourseID"));

        $.ajax(
            {
                url: skyward.global.virtualDir + "Scheduling/Section/SetFiltersOnSectionBrowse",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    CourseID: courseID
                },
                success: function (data)
                {
                    browse.dynamicFilterValues.filter = data.SearchCondition;
                    browse.dynamicFilterValues.filter_hash = data.SearchConditionHash;
                    skyward.browse.get("SectionsToMove", {});
                }
            });
    };

    //Bootstrap
    skyward.window.registerLoadDOMCallback(init);

}(window.skyward = window.skyward || {}, window.jQuery)
);